"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMOTIONS_AI = void 0;
/**
 * These are ids of all possible provider criterias on Prod
 *  (ids might vary in staging).
 */
exports.EMOTIONS_AI = 1024;
//# sourceMappingURL=providerTypes.js.map